import { useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import Button from '../../../../layout/components/Button';
import Modal from '../../../../layout/components/Modal';

import RoundedCheckIcon from '../../../../layout/styles/images/rounded-check-icon.svg';

import '../styles/instructions.scss';

const SendConfirmationModal = function (props) {
  const navigate = useNavigate();

  const onCloseClick = () => {
    props.setIsConfirmationModalOpen(false);
    navigate(`/blocked`);
  };

  return (
    <Modal
      className={`form-sent-confirmation-modal`}
      hideCloseBtn={true}
      showModal={props.isConfirmationModalOpen}
      onCloseModal={() => {
        props.setIsConfirmationModalOpen(false);
      }}>
      <ReactSVG src={RoundedCheckIcon} />
      <p>Port Clearance form sent!</p>
      <Button className="generate-form-btn" onClick={onCloseClick}>
        Close
      </Button>
    </Modal>
  );
};

export default SendConfirmationModal;
